import { useState } from 'react';

export default function VoteButtons({ reportId, yesCount, noCount, onVote }) {
  const [voting, setVoting] = useState(null);
  
  const handleVote = async (vote) => {
    setVoting(vote);
    await onVote(reportId, vote);
    setVoting(null);
  };
  
  return (
    <div>
      <div className="vote-buttons">
        <button 
          className="vote-btn yes"
          onClick={() => handleVote(1)}
          disabled={voting !== null}
        >
          ✓ আছে
        </button>
        <button 
          className="vote-btn no"
          onClick={() => handleVote(-1)}
          disabled={voting !== null}
        >
          ✗ নেই
        </button>
      </div>
    </div>
  );
}
